import axios from 'axios';

// setup axios interceptor
axios.interceptors.request.use(
  (config) => {
    // try to get token from storage
    // based on state/modules/auth.js keys
    const token = sessionStorage.getItem("auth.token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
